import { useNavigate } from "@Light/utils/context";
import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

export type Mode = "month" | "year";

export type ModeSelectorProps = {
  selectedMode: Mode;
};

export const ModeSelector: React.FC<ModeSelectorProps> = ({ selectedMode }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const monthButton = (
    <ModeButton
      mode="month"
      selectedMode={selectedMode}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
  const yearButton = (
    <ModeButton
      mode="year"
      selectedMode={selectedMode}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
  return (
    <div className="relative">
      {selectedMode === "month" ? monthButton : yearButton}
      <div className="absolute top-10 left-0">
        {isOpen && (selectedMode === "month" ? yearButton : monthButton)}
      </div>
    </div>
  );
};

export type ModeButtonProps = {
  mode: Mode;
  selectedMode: Mode;
  isOpen: boolean;
  setIsOpen: (v: boolean) => void;
};

export const ModeButton: React.FC<ModeButtonProps> = ({
  mode,
  selectedMode,
  isOpen,
  setIsOpen,
}) => {
  const navigate = useNavigate();
  const selected = selectedMode === mode;
  const onClick = () => {
    if (mode === selectedMode) {
      setIsOpen(!isOpen);
      return;
    }
    navigate(`/dash/usage?${new URLSearchParams({ mode })}`);
    setIsOpen(false);
  };
  return (
    <div
      className={clsx("border rounded-lg cursor-pointer w-20", "bg-white")}
      onClick={onClick}
    >
      <div className="flex flex-row justify-between p-2 gap-1">
        <div className="text-xs">
          {mode.charAt(0).toUpperCase() + mode.slice(1)}
        </div>
        <div className="w-4 h-4">{selected && <ChevronDownIcon />}</div>
      </div>
    </div>
  );
};
